<div class="flex flex-row">
  <h2 class="page-header">Bedrijven</h2>
  <button
    mat-flat-button
    class="action-button"
    style="margin: 20px"
    (click)="createCompany()"
  >
    + Nieuw bedrijf
  </button>
</div>
<div class="table-container panel">
  <div class="example-table-container">
    <table
      mat-table
      [dataSource]="companies"
      class="example-table"
      matSort
      matSortActive="regularName"
      matSortDisableClear="true"
      matSortDirection="asc"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle" [mat-sort-header]="">
              <b>Nr</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('id')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">#{{ row.id }}</td>
      </ng-container>

      <ng-container matColumnDef="discountGroup">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle" [mat-sort-header]="">
              <b>Kortingsgroep</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('discountGroup')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.discountGroup }}
        </td>
      </ng-container>

      <ng-container matColumnDef="regularName">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle extra-right" [mat-sort-header]="">
              <b>Naam</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('regularName')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.regularName
          }}<ng-container *ngIf="!row.dataCorrect"
            ><mat-icon
              matTooltip="Bedrijf nog niet vervolledigd"
              class="data-not-correct-icon"
              >report_problem</mat-icon
            ></ng-container
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="addresses">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle extra-right">
              <b>Adres</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('addresses')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.address }}
        </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle extra-right">
              <b>Telefoonnummer</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('telephones__number')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.phoneNumber | asFormatPhoneNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle extra-right">
              <b>Email</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('emails__email')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          <a
            *ngIf="row.email?.length > 0"
            class="click-link"
            href="mailto:{{ row.email }}"
            (click)="$event.stopPropagation()"
            >{{ row.email }}</a
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <b>Website</b>
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          <a
            *ngIf="row.website?.length > 0"
            class="click-link"
            [href]="row.website"
            hrefExternalUrl
            >{{ row.website }}</a
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="star" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="header-text"></th>
        <td
          mat-cell
          *matCellDef="let element"
          (click)="$event.stopPropagation()"
          class="table-text"
        >
          <mat-menu #actionMenu="matMenu" class="table-text">
            <button
              mat-menu-item
              [routerLink]="['/bedrijven', element.id]"
              class="center-text"
            >
              <mat-icon class="center-text">edit</mat-icon> Bewerken
            </button>
            <button
              mat-menu-item
              (click)="deleteCompany(element)"
              class="center-text"
            >
              <mat-icon class="center-text">delete</mat-icon> Verwijderen
            </button>
          </mat-menu>
          <div class="text-middle">
            <mat-icon class="fa-2x" [matMenuTriggerFor]="actionMenu"
              >more_vert</mat-icon
            >
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        class="table-row"
        [routerLink]="['/bedrijven', row.id]"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
  ></mat-paginator>
</div>
